import React from "react";
import {
  Table,
  TableCell,
  TableRow,
  TableContainer,
  TableHead,
  TableBody,
  Paper,
  makeStyles,
  createStyles,
  Theme,
  Checkbox,
} from "@material-ui/core";
import { Loading } from "../../components/Loading";
import { ISource } from "../../core/redux/dataMap/source";
import useLanguage from "../../hooks/useLanguage";

interface ISourcesTableProps {
  sources: ISource[];
  isAllChecked: boolean;
  isLoading: boolean;
  updateUserSource(source: ISource): void;
  toggleAllSources(): void;
}

export const SourcesTable: React.FC<ISourcesTableProps> = ({
  sources,
  isAllChecked,
  isLoading,
  updateUserSource,
  toggleAllSources,
}) => {
  const classes = useStyles();
  const { language } = useLanguage();
  const { translate } = language;
  return (
    <div className={classes.root}>
      <Paper elevation={1}>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell padding="checkbox">
                  <Checkbox
                    checked={isAllChecked}
                    onChange={() => toggleAllSources()}
                    color="secondary"
                  />
                </TableCell>
                <TableCell></TableCell>
                <TableCell>{translate.source}</TableCell>
                <TableCell>{translate.description}</TableCell>
                <TableCell>{translate.source_type}</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {isLoading ? (
                <TableRow>
                  <TableCell colSpan={5}>
                    <Loading />
                  </TableCell>
                </TableRow>
              ) : (
                sources &&
                sources.map((source, index) => {
                  return (
                    <TableRow
                      hover
                      onClick={() => updateUserSource(source)}
                      role="checkbox"
                      aria-checked={source.isUserSaved}
                      tabIndex={-1}
                      key={index}
                      selected={source.isUserSaved}
                      className={classes.row}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={source.isUserSaved}
                          // onChange={() => handleFilterSourceChange(source)}
                          color="secondary"
                        />
                      </TableCell>
                      <TableCell>
                        {!!source.logo && source.logo !== null && (
                          <img
                            src={source.logo}
                            width="50"
                            height="50"
                            alt="sourceLogo"
                          />
                        )}
                      </TableCell>
                      <TableCell align="left">{source.name}</TableCell>
                      <TableCell align="left">{source.description}</TableCell>
                      <TableCell align="left">{source.type}</TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Paper>
    </div>
  );
};

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      marginTop: "20px",
    },
    row: {
      cursor: "pointer",
    },
  })
);
